import { render, staticRenderFns } from "./aitutor.vue?vue&type=template&id=4e2798f6&"
import script from "./aitutor.vue?vue&type=script&lang=js&"
export * from "./aitutor.vue?vue&type=script&lang=js&"
import style0 from "./aitutor.vue?vue&type=style&index=0&id=4e2798f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports